<template>
  <div class="statistic-widget-design-idea-quantity">
    <h5 class="mb-0 title">Design Idea Quantity</h5>
    <Chart :config="chartConfig" class="chart" />
  </div>
</template>

<script>
import Chart from '@/components/Chart.vue'
export default {
  components: {
    Chart
  },
  data() {
    return {
      selected: 'today'
    }
  },
  computed: {
    data() {
      return this.config?.data
    },
    chartConfig() {
      let options = {
        chart: {
          type: 'column'
        },
        yAxis: [{ visible: false }, { visible: false }],
        tooltip: {
          crosshairs: true,
          shared: true,
          headerFormat: `<b>${this.data?.labels?.label}: {point.x}</b><br>`
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            borderRadius: {
              radius: '50%',
              where: 'all'
            },
            pointWidth: 12
          }
        }
      }
      return {
        options: Object.assign(options, this.options(this.data || {}))
      }
    }
  },
  methods: {
    options(items) {
      let results = {
        categories: [],
        columns: {}
      }

      items?.data.forEach((values) => {
        results.categories.push(values?.label)
        Object.entries(items?.labels?.roles).forEach(([role, roleName]) => {
          Object.entries(items?.labels?.statuses).forEach(([status, statusName]) => {
            if (!results.columns?.[`${role}|${status}`]) {
              results.columns[`${role}|${status}`] = {
                name: `${roleName}(${statusName})`,
                stack: statusName,
                data: []
              }
            }
            results.columns[`${role}|${status}`].data.push(values?.items?.[role]?.[status] || 0)
          })
        })
      })

      results.columns = Object.values(results.columns).filter((items) => {
        return items.data.some((item) => item !== 0)
      })

      return {
        xAxis: {
          categories: results.categories,
          lineWidth: 0
        },
        series: results.columns
      }
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.statistic-widget-design-idea-quantity {
  .chart {
    max-height: 350px;
  }
}
</style>
